export class Parameter {
  id: number;
  configurationId: number;
  stackId: number;
  careSettingId: number;
  customerId: number;
  key: string;
  value: string;
  environmentKey: string;
  corpOid: any;
  createdBy: string;
  modifiedBy: string;

  public constructor(init?: Partial<Parameter>) {
    Object.assign(this, init);
  }
}
